"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var components_1 = require("./components");
var Page = function (_a) {
    var _b;
    var _c = _a.align, align = _c === void 0 ? 'center' : _c, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? 'neutral-10' : _d, children = _a.children, className = _a.className, header = _a.header, headerAlign = _a.headerAlign, footer = _a.footer, _e = _a.maxWidth, maxWidth = _e === void 0 ? 'default' : _e, minWidth = _a.minWidth, sidebar = _a.sidebar, _f = _a.spacing, spacing = _f === void 0 ? 'relaxed' : _f, actionToolbar = _a.actionToolbar, panel = _a.panel, props = __rest(_a, ["align", "backgroundColor", "children", "className", "header", "headerAlign", "footer", "maxWidth", "minWidth", "sidebar", "spacing", "actionToolbar", "panel"]);
    var PageClasses = classnames_1.default('Page', className, "bg-" + backgroundColor, {
        'Page--align-center': align === 'center',
        'Page--no-padding': spacing === 'none',
        'Page--relaxed': spacing === 'relaxed',
        'Page--wide': maxWidth === 'wide',
        'Page--narrow': maxWidth === 'narrow',
        'Page--min-width': minWidth,
    });
    var isToolbar = react_1.isValidElement(actionToolbar === null || actionToolbar === void 0 ? void 0 : actionToolbar.content);
    var isPanel = react_1.isValidElement(panel === null || panel === void 0 ? void 0 : panel.content);
    var panelPosition = (_b = panel === null || panel === void 0 ? void 0 : panel.position) !== null && _b !== void 0 ? _b : 'right';
    return (react_1.default.createElement("div", __assign({ className: PageClasses }, props),
        sidebar && react_1.default.createElement("div", { className: "Page__sidebar" }, sidebar),
        react_1.default.createElement("div", { className: "Content__wrapper" },
            isToolbar && react_1.default.createElement(components_1.ActionToolbar, __assign({}, actionToolbar)),
            react_1.default.createElement(utilities_1.ConditionalWrapper, { condition: isPanel, wrapper: function (children) { return (react_1.default.createElement("div", { className: "Panel__wrapper" }, children)); } },
                isPanel && panelPosition === 'left' && (react_1.default.createElement(components_1.Panel, __assign({}, panel))),
                react_1.default.createElement("div", { className: "Page__page" },
                    header && react_1.default.createElement("div", { className: "Page__header" }, header),
                    react_1.default.createElement("div", { className: "Page__content" }, children)),
                isPanel && panelPosition === 'right' && (react_1.default.createElement(components_1.Panel, __assign({}, panel)))),
            footer && react_1.default.createElement("div", { className: "Page__footer" }, footer))));
};
exports.Page = Page;
//# sourceMappingURL=Page.js.map